import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useQuery, useMutation } from "react-query";
import { getCheckResetHash, postUserPasswordUpdate } from "../common/api";
import { Container, Row, Col, Card, Form, Button, Modal, Spinner, Alert, InputGroup } from "react-bootstrap";

import { FaEye, FaEyeSlash } from "react-icons/fa";


const ResetPasswordComponent = () => {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const [newPassword, setNewPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [operationModalMsg, setOperationModalMsg] = useState("");

    const getCheckResetHashQuery = useQuery(
        ['resetHash', {}], // Unikalny identyfikator zapytania
        () => getCheckResetHash(queryParams.get('hash')), // Funkcja wykonująca zapytanie
        {
          enabled: true,
          retry: false,
          refetchOnWindowFocus: true
        }
      );

    const postUpdatePasswordMutation = useMutation(
        {
            mutationFn: () => postUserPasswordUpdate(newPassword, queryParams.get('hash')),
            onSuccess: (data) => {
                setShowModal(true);
                setLoading(false);
                setRepeatPassword("");
                setNewPassword("");
                setOperationModalMsg('<p>Operacja zmiany hasła przebiegła pomyślnie, możesz już się <a href="/authorization">zalogować</a></p>')
            },
            onError: (error) => {
                setShowModal(true);
                setLoading(false);
                setOperationModalMsg('<p>Niestety, wystąpił błąd, spróbuj ponownie później.</p>')
            }
        }
    );

    useEffect(() => {
        if(getCheckResetHashQuery.isFetched && getCheckResetHashQuery.isStale){
            if(getCheckResetHashQuery.isError){
                window.location.href="/";
            }
        }
    }, [getCheckResetHashQuery])

    const showPasswordButtonClickHandler = (e) => {
        setShowPassword(!showPassword);
    }

    const showPasswordRepeatButtonClickHandler = (e) => {
        setShowRepeatPassword(!showRepeatPassword);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setMsg("");
        if(newPassword !== repeatPassword){
            setMsg('<span class="text-danger">Podane hasła się nie zgadzają. Spróbuj ponownie.</span>')
            return;
        }

        setLoading(true);
        postUpdatePasswordMutation.mutate()

    }

    const handleModalClose = () => {
        setShowModal(false);
    }

    return(
        <React.Fragment>
        <Container className="resetPasswordForm">
  
        <Row className="pt-5">
          <Col sm={12} md={12} lg={12}>
  
            <Row>
              <Col className="col-lg-8 col-10 offset-lg-2 offset-1">
                <div id="loginForm" className="border border-0 put-shadow card">
                  <div className="cart-body">
  
                    <Row className="mb-4">
                      <Card.Title className="text-center h2 mb-4">Twoje hasło zostało pomyślnie zresetowane. Teraz możesz ustawić nowe hasło. Wpisz nowe hasło dwukrotnie i zatwierdź formularz.</Card.Title>
                    </Row>

                    <Alert variant="info" className="text-center">
                    Uwaga! Twoje hasło ulegnie zmianie również na Twoim koncie na Klett.pl.
                    </Alert>

  
                    <Form className="border border-end-0 border-start-0 py-4 my-4" onSubmit={(e) => handleSubmit(e)}>
                      <Form.Group className="mb-4">
                        <Form.Label className="w-100 form-label">Podaj nowe hasło</Form.Label>
                        <InputGroup>
                            <Form.Control disabled={loading} placeholder="Podaj nowe hasło" type={showPassword ? "text" : "password"} name="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required/>
                            <Button disabled={loading} variant="outline-secondary" onClick={(e) => showPasswordButtonClickHandler(e)}>{!showPassword ? <FaEye /> : <FaEyeSlash />}</Button>
                        </InputGroup>
                      </Form.Group>

                      <Form.Group className="mb-4">
                        <Form.Label className="w-100 form-label">Powtórz nowe hasło</Form.Label>
                        <InputGroup>
                            <Form.Control disabled={loading} placeholder="Powtórz nowe hasło" type={showRepeatPassword ? "text" : "password"} name="password_repeat" value={repeatPassword} onChange={(e) => setRepeatPassword(e.target.value)} required/>
                            <Button disabled={loading} variant="outline-secondary" onClick={(e) => showPasswordRepeatButtonClickHandler(e)}>{!showRepeatPassword ? <FaEye /> : <FaEyeSlash />}</Button>
                        </InputGroup>
                      </Form.Group>

                      <div dangerouslySetInnerHTML={{__html: msg}}></div>
                    
  
                      <Button className="btn-primary w-100 mt-2" type="submit" disabled={loading}>{loading ? <Spinner size="sm" /> : 'Resetuj hasło'}</Button>
                    </Form>

                    <Modal show={showModal} backdrop="static" keyboard={false}>
                        <Modal.Body dangerouslySetInnerHTML={{__html: operationModalMsg}}></Modal.Body>
                    </Modal>

  
                </div>
              </div>
              </Col>
            </Row>
  
          
          </Col>
        </Row>
  
  
        
        </Container>
  
        
  
      </React.Fragment>
    )

}

export default ResetPasswordComponent;